import { useState } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { FormStep1, FormStep2, FormStep3 } from './formStep'
import {
    initialValues,
    validateStep,
    cleanCommaField,
    handleDateChange,
} from './utilities'
import ProgressStepper from './progressStepper'
import { FormHeader } from './formHeader'
import Header from 'components/headers/bulletins'
import SuccessStep from './formStep/successStep'
import { publishPromissory } from 'services/promissory'

const handleSubmit = async (values, { setSubmitting, resetForm, setStep }) => {
    const cleanedDataFields: any = cleanCommaField(values)
    try {
        const response = await publishPromissory(cleanedDataFields)
        const firstResonseData = Object.values(response.data)[0]
        if (response.status === 200) {
            toast.success(`${firstResonseData}`)
            setStep(3)
        } else if (response.status === 203) {
            toast.info(`${firstResonseData}`)
        }
    } catch (error: any) {
        if (error.response) {
            const firstErrorMessage = Object.values(error.response.data)[0]
            toast.error(`${firstErrorMessage}`)
        } else if (error.request) {
            toast.error('server error')
        } else if (error.message === 'Network Error') {
            toast.error('Network Error')
        } else {
            toast.error('error')
        }
    } finally {
        setSubmitting(false)
    }
}

export const PromissoryPublish = () => {
    const [step, setStep] = useState<number>(0)

    const handleNext = async (
        validateForm: () => Promise<any>,
        setTouched: (touched: { [key: string]: boolean }) => void
    ) => {
        try {
            const errors = await validateForm()
            const stepFields =
                {
                    0: [
                        'issuerIdCode',
                        'issuerName',
                        'issuerIban',
                        'issuerIdType',
                        'issuerPostalCode',
                        'issuerAddress',
                        'issuerMobile',
                    ],
                    1: [
                        'receiverName',
                        'receiverIdCode',
                        'receiverIdType',
                        'receiverMobile',
                    ],
                    2: ['amount', 'duDate', 'description', 'paymentPlace'],
                }[step] || []

            const filteredErrors = Object.keys(errors).reduce((acc, key) => {
                if (stepFields.includes(key)) {
                    acc[key] = errors[key]
                }
                return acc
            }, {} as any)

            setTouched(
                Object.keys(filteredErrors).reduce(
                    (acc, key) => {
                        acc[key] = true
                        return acc
                    },
                    {} as { [key: string]: boolean }
                )
            )

            if (Object.keys(filteredErrors).length === 0) {
                setStep((prevStep) => prevStep + 1)
            } else {
                toast.error('لطفاً اطلاعات را به درستی وارد کنید')
            }
        } catch (err) {
            console.error('Validation error:', err)
        }
    }

    const handlePrevious = () => {
        setStep((prevStep) => prevStep - 1)
    }

    return (
        <div>
            <Header title="صدور پیش نویس سفته" />
            <div className="container mx-auto px-4 text-green-1 text-left">
                <Formik
                    initialValues={initialValues}
                    onSubmit={(values, actions) =>
                        handleSubmit(values, { ...actions, setStep })
                    }
                    validate={(values) => validateStep(values, step)}
                    validateOnChange={true}
                    validateOnBlur={true}
                >
                    {({
                        isSubmitting,
                        setFieldValue,
                        values,
                        errors,
                        touched,
                        validateForm,
                        setTouched,
                    }) => (
                        <Form className="max-w-md mx-auto bg-white rounded px-8 pt-6 pb-8 mb-4">
                            {step < 3 && (
                                <>
                                    <ProgressStepper
                                        step={step}
                                        validateStep={validateStep}
                                        setStep={setStep}
                                        values={values}
                                    />
                                    <FormHeader step={step} />
                                </>
                            )}
                            {step === 0 && (
                                <FormStep1 setFieldValue={setFieldValue} />
                            )}
                            {step === 1 && (
                                <FormStep2 setFieldValue={setFieldValue} />
                            )}
                            {step === 2 && (
                                <FormStep3
                                    handleDateChange={handleDateChange}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                />
                            )}
                            {step < 3 && (
                                <div className="flex items-center justify-between mt-4">
                                    {step > 0 && (
                                        <button
                                            type="button"
                                            className="bg-gray-5 hover:bg-gray-1 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            onClick={handlePrevious}
                                        >
                                            قبل
                                        </button>
                                    )}
                                    {step < 2 && (
                                        <button
                                            type="button"
                                            className="bg-green-1 hover:bg-green-1 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            onClick={() =>
                                                handleNext(
                                                    validateForm,
                                                    setTouched
                                                )
                                            }
                                        >
                                            بعدی
                                        </button>
                                    )}
                                    {step > 1 && (
                                        <button
                                            type="submit"
                                            className="bg-green-1 hover:bg-green-1 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting
                                                ? 'در حال ارسال...'
                                                : 'ارسال'}
                                        </button>
                                    )}
                                </div>
                            )}
                            {step === 3 && <SuccessStep />}
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}
